import { render } from "./FavoriteApartments.vue?vue&type=template&id=43ca92c4&scoped=true"
import script from "./FavoriteApartments.vue?vue&type=script&lang=js"
export * from "./FavoriteApartments.vue?vue&type=script&lang=js"

import "./FavoriteApartments.vue?vue&type=style&index=0&id=43ca92c4&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ca92c4"]])

export default __exports__